<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">3.4、删除表</h1>
					<h2 class="about-cs">3.4.1概念</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 删除数据库里的表好比菜老板突然有一天把商店改为菜店了，以前的商品信息笔记本的内容都没用了，所以他就把以前的记录商品信息的笔记本扔掉，扔这个动作对应drop这个语句。</br>
						&nbsp; &nbsp; 注：删除表的动作执行时，不管表里是否记录有信息都会直接把表和表里的内容一起删除掉。
					</div>
					<h2 class="about-cs">3.4.2删除语句</font></h2>
					
					<div class="about-t">
 
						删除表语句：</br>
						<sql-show value="drop table PRODUCT_T;"> </sql-show>
		 
						语句解释：</br>
						<change-key-word keyword="drop table：" text="drop table：是删除表的语法记住就行。"></change-key-word><br />
						<change-key-word keyword="PRODUCT_T：" text="PRODUCT_T：是告诉数据库删除PRODUCT_T（商品信息）这张表"></change-key-word><br />
						注：删除标后在执行查询语句select * from  PRODUCT_T报错信息如下</br>  
						[Err] 1146 - Table 'product_t' doesn't exist
						 
					</div>
					 
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ChangeKeyWord from '@/components/project/ChangeKeyWord.vue'

	import SqlShow from '@/components/project/SqlShow.vue'
	export default {
		components: {
			ChangeKeyWord,
			SqlShow,
		},

		data() {
			return {
				userId: '',
				ifLogin: false,
				sqlInfo: 'insert into PRODUCT_T \r\n' +
					     '(PRODUCT_NO,  PRODUCT_NAME,  PRODUCT_NUM,     PRODUCT_PRICE  ) \r\n' +
					     'values\r\n' +
					     '(\'NO099\',   \'晨光中性笔\',  100,          1.52        );\r\n'  ,
	 
			}
		},

		created() {
			this.userId = this.$store.state.userInfo.userId;
			if (this.userId != undefined) {
				this.ifLogin = true;
			}
			console.log('userId:' + this.userId);
		},
		computed: {

		},
		methods: {

			toRunSql() {
				if (this.ifLogin == true) {
					let routeUrl = this.$router.resolve({
						path: '/run',
					})
					window.open(routeUrl.href, '_blank')
				} else {
					this.$Message.warning('登录后才能使用该功能！');
				}
			}

		},

	}
</script>

<style lang="scss" scoped>
	//写上样式
	.keyWord {
		color: #0fbda0;
	}


	#vip {
		color: red;
	}

	.about-xs {
 
		margin-bottom: 20px;
		margin-top: 10px;
	}

	//标题字体
	  h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}
	
	h2.about-little {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 20px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
	.aw-register-box .mod-body .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 20px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}

	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
